document.addEventListener("DOMContentLoaded", function () {
   function returnPaginationBullet(index, className) {
    return (
      '<span class="h-[3px]! transition-all duration-300 text-[14px]! m-0! pb-[2px]! inline-block! w-[20px]! ' +
      className +
      '">'+
      "</span>"
    );
  }
  // 初始化
  new Swiper(".imgSwiper", {
    speed: 400,
    spaceBetween: 100,
    pagination: {
      el: ".imgSwiper .swiper-pagination",
      clickable: true,
      renderBullet: function (index, className) {
       return returnPaginationBullet(index, className);
      },
    },
  });

  //视频swiper
  new Swiper(".videoSwiper", {
    speed: 400,
    spaceBetween: 100,
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1.3,
        spaceBetween: 10,
      },
      // when window width is >= 480px
      480: {
        slidesPerView: 1.3,
        spaceBetween: 20,
      },
      // when window width is >= 640px
      640: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
      960: {
        slidesPerView: 5,
        spaceBetween: 20,
      },

    },
    navigation: {
      nextEl: ".videoSwiper .swiper-button-next",
      prevEl: ".videoSwiper .swiper-button-prev",
    },
    pagination: {
      el: ".videoSwiper .swiper-pagination",
      clickable: true,
      renderBullet: function (index, className) {
       return returnPaginationBullet(index, className);
      },
    },
  });

  // Top Picks
   new Swiper(".topSwiper", {
    speed: 400,
    autoHeight: true,
    spaceBetween: 100,
    pagination: {
      el: ".topSwiper .swiper-pagination",
      clickable: true,
      renderBullet: function (index, className) {
       return returnPaginationBullet(index, className);
      },
    },
    navigation: {
      nextEl: ".topSwiper .swiper-button-next",
      prevEl: ".topSwiper .swiper-button-prev",
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      // when window width is >= 480px
      480: {
        slidesPerView: 1,
        spaceBetween: 30,
      },
      // when window width is >= 640px
      640: {
        slidesPerView: 2,
        spaceBetween: 40,
      },
    },
  });
  // 产品
  new Swiper(".topProductSwiper", {
    speed: 400,
    autoHeight: true,
    spaceBetween: 100,
    pagination: {
      el: ".topProductSwiper .swiper-pagination",
      clickable: true,
      renderBullet: function (index, className) {
       return returnPaginationBullet(index, className);
      },
    },
    navigation: {
      nextEl: ".topProductSwiper .swiper-button-next",
      prevEl: ".topProductSwiper .swiper-button-prev",
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      // when window width is >= 480px
      480: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      // when window width is >= 640px
      640: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    },
  });
  // 产品
  new Swiper(".withUsSwiper", {
    speed: 400,
    slidesPerView: 1,
    autoHeight: true,
    spaceBetween: 100,
    pagination: {
      el: ".withUsSwiper .swiper-pagination",
      clickable: true,
      renderBullet: function (index, className) {
       return returnPaginationBullet(index, className);
      },
    },
    navigation: {
      nextEl: ".withUsSwiper .swiper-button-next",
      prevEl: ".withUsSwiper .swiper-button-prev",
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1.3,
        spaceBetween: 10,
      },
      // when window width is >= 480px
      480: {
        slidesPerView: 1.3,
        spaceBetween: 20
      },
      // when window width is >= 640px
      640: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      960: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
    },
  });

  // Innovation
  let fixing = false;
  new Swiper(".mySwiper", {
    slidesPerView: 1,
    centeredSlides: true,
    speed: 400,
    spaceBetween: 36,
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      // when window width is >= 480px
      480: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      // when window width is >= 640px
      768: {
        slidesPerView: 1,
        spaceBetween: 36,
      },
    },
    loop: true,
    autoplay: {
      delay: 3000,
    },
    loopedSlides: 3,
    pagination: {
      el: ".mySwiper .swiper-pagination",
      clickable: true,
    },
    on: {
      slideChangeTransitionEnd(swiper) {
        if (fixing) return;
        fixing = true;
        setTimeout(() => {
          swiper.loopFix();
          swiper.autoplay.start();
          fixing = false;
        }, 80);
      },
    },
    navigation: {
      nextEl: ".mySwiper .swiper-button-next",
      prevEl: ".mySwiper .swiper-button-prev",
    },
  });
});
